import React, { type JSX, ReactElement, ReactNode } from 'react';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Stack, useTheme } from '@mui/material';

type Props = {
  isOpen: boolean;
  toggleIsOpen: () => void;
  title: string;

  titleIcon?: ReactElement;
  children: ReactNode;
};

export const NavigationAccordion = ({
  isOpen,
  toggleIsOpen,
  title,
  titleIcon,
  children,
}: Props): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        '.MuiPaper-root': {
          boxShadow: 'none',
        },
        '.MuiAccordionSummary-root': {
          padding: '0 1rem',
          borderRadius: 2,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        '.MuiAccordionSummary-content': {
          margin: 0,
        },
      }}
    >
      <MuiAccordion
        expanded={isOpen}
        onChange={toggleIsOpen}
        disableGutters={true}
      >
        <MuiAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              '> svg': {
                color: theme.palette.action.active,
                marginRight: 3,
              },
            }}
          >
            {!!titleIcon && titleIcon}
          </Box>
          <Typography
            variant="button"
            sx={{
              fontWeight: 500,
            }}
          >
            {title}
          </Typography>
        </MuiAccordionSummary>
        <MuiAccordionDetails sx={{ px: '0 !important' }}>
          <Stack>{children}</Stack>
        </MuiAccordionDetails>
      </MuiAccordion>
    </Box>
  );
};
